import { ParticipantAccommodationReportTemplateData } from "./ParticipantAccommodationReportTemplateData";
import { backgroundLogo, headerLogo } from "../constants/PdfReports";
import { formatDate } from "../core/Utility";

export const ParticipantAccommodationReportImportTemplate = (
    data: ParticipantAccommodationReportTemplateData
    ) => {

    return {
        background: [
            {
                image: backgroundLogo,
                width: 580,
                alignment: 'center',
                absolutePosition: {x: 0, y: 200}
            }
        ],
        header: [],
        footer: [],
        content: [
            {
                image: headerLogo,
                alignment: 'center',
                margin:[0,5,0,0]
            },
            {
                text: `Lista učesnika u smeštaju ${data.accommodationName}`,
                style: 'title',
                margin:[0,20,0,5]
            },
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }],
                margin:[0,5,0,10]
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['11%','11%','25%','14%','8%','14%','7%', '10%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '100%',
                                        text: `Ime: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        width: '100%',
                                        text: `Prezime: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Događaj: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Datum smeštaja: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Broj osoba: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Tip sobe: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Broj sobe: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `Status: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }],
                margin:[0,5,0,10]
            },
            data.reportData?.map((item) => {
                return ({
                    width: '50%',
                    layout: 'noBorders',
                    table: {
                        widths: ['11%','11%','25%','14%','8%','14%','7%', '10%'],
                        body: [
                            [
                                {
                                    columns: [
                                        {
                                            text: `${item.firstName ?? ''}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.lastName ?? ''}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.eventname}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.dateFrom} - ${item.dateTo}`,
                                            style: 'textLeft',
                                            bold: false,
                                            margin:[0,0,0,0]
                                        },
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.numberPersonInRoom}`,
                                            style: 'textLeft',
                                            margin:[0,0,0,0]
                                        }
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.roomtypename}`,
                                            style: 'textLeft',
                                            margin:[0,0,0,0]
                                        }
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.roomNumber ?? ''}`,
                                            style: 'textLeft',
                                            margin:[0,0,0,0]
                                        }
                                    ]
                                },
                                {
                                    columns: [
                                        {
                                            text: `${item.registration_status}`,
                                            style: 'textLeft',
                                            margin:[0,0,0,0]
                                        }
                                    ]
                                },
                            ]
                        ]
                    }
                }
            )}),
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }],
                margin:[0,5,0,10]
            },
        ],
        styles: {
            title: {
                fontSize: '14',
                alignment: 'center',
                margin:[0,20,0,10],
                bold: true
            },
            textLeft: {
                fontSize: '10',
                alignment: 'left',
            },
            textRight: {
                fontSize: '10',
                alignment: 'right',
            }
        }
    }
}